'use client';
import { useEffect, useState } from 'react';

/** 使用會員首次建檔時間，重新登入或重新整理不會延長提示期限。 */
export function MemberRecoveryNotice({ expiresAt }: { expiresAt: string | null }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const remaining = expiresAt ? Date.parse(expiresAt) - Date.now() : 0;
    if (!Number.isFinite(remaining) || remaining <= 0) { setVisible(false); return; }
    setVisible(true);
    const timer = window.setTimeout(() => setVisible(false), Math.min(remaining, 86400000));
    const check = () => { if (Date.now() >= Date.parse(expiresAt!)) setVisible(false); };
    window.addEventListener('focus', check);
    return () => { window.clearTimeout(timer); window.removeEventListener('focus', check); };
  }, [expiresAt]);
  if (!visible) return null;
  return <aside className="member-recovery-notice"><div><strong>已在店家購買課程？</strong><p>可選擇驗證手機或請店家協助，找回既有課程。</p></div><a href="/member/complete">找回既有課程</a></aside>;
}
